import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton, BaasicDropdown, Loader } from 'core/components';
import ReactTooltip from 'react-tooltip';
import _ from 'lodash';

function CancelTemplate({
	cancelViewStore: { form, loading, cancelReasonDropdownStore, isSuperAdminOrganization, selectedItem, openVoidActiveLabelConfirmModal, isMarketplaceOrder },
	t,
}) {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h2 className="spc--bottom--sml">
						{isSuperAdminOrganization ? t('CANCELVIEW.CANCEL') : t('CANCELVIEW.REQUESTTOBECANCELLED')}
					</h2>
				</div>
				<div className="ReactModal__body">
					<ReactTooltip />
					<BaasicDropdown
						additionalLabel={
							isSuperAdminOrganization && _.get(selectedItem, 'requestedCancelReasonId') != null
								? () => (
										<i
											data-tip={t('CANCELVIEW.REASONSELECTED')}
											className="fas fa-exclamation-circle spc--left--tny"
										></i>
								  )
								: null
						}
						dropdownStore={cancelReasonDropdownStore}
						isClearable={true}
						label={t('CANCELVIEW.CANCELREASON')}
					/>
				</div>
				<div className="ReactModal__footer">
					{!isMarketplaceOrder ? (
						<BaasicButton
							className="btn btn--med btn--primary spc--bottom--sml"
							label="SAVE"
							type="button"
							onClick={openVoidActiveLabelConfirmModal}
							disabled={form.$('cancelReasonId').isEmpty}
						/>
					) : (
						<div className="ReactModal__footer">
							<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
								{t('SAVE')}
							</button>
						</div>
					)}
				</div>
			</form>
		</section>
	);
}

export default defaultTemplate(CancelTemplate);
